import { Card } from "@/components/ui/card";
import { ShoppingCart, TrendingUp, Users, Globe, BarChart, Zap } from "lucide-react";

export const FeaturesGrid = () => {
  const features = [
    {
      icon: <ShoppingCart className="h-8 w-8 text-blue-600" />,
      title: "Custom Storefronts",
      description: "Beautiful, responsive online stores that convert visitors into customers."
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-blue-600" />,
      title: "Growth & Analytics",
      description: "Automated Data-driven insights and marketing tools to scale your business."
    },
    {
      icon: <Users className="h-8 w-8 text-blue-600" />,
      title: "Customer Experience",
      description: "Seamless shopping experiences across all devices and platforms."
    },
    {
      icon: <Globe className="h-8 w-8 text-blue-600" />,
      title: "AI Powered Agents",
      description: "Smart agents that personalize shopping experiences, automate operations, and optimize sales with multi-language, multi-currency capabilities for global success."
    },
    {
      icon: <BarChart className="h-8 w-8 text-blue-600" />,
      title: "Inventory Management",
      description: "Real-time stock tracking and automated order processing."
    },
    {
      icon: <Zap className="h-8 w-8 text-blue-600" />,
      title: "Performance Optimization",
      description: "Lightning-fast loading times and optimal conversion rates."
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">
          Comprehensive eCommerce Solutions
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};